var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderList"},[_c('Head'),_c('MidSearch'),_c('div',{staticClass:"main_view"},[_c('Nav'),_c('AppMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }